/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlannerMessageResponse
 */
export interface PlannerMessageResponse {
    /**
     * 
     * @type {string}
     * @memberof PlannerMessageResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PlannerMessageResponse
     */
    role: string;
    /**
     * 
     * @type {string}
     * @memberof PlannerMessageResponse
     */
    content?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlannerMessageResponse
     */
    toolName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlannerMessageResponse
     */
    toolCallId?: string | null;
    /**
     * 
     * @type {object}
     * @memberof PlannerMessageResponse
     */
    toolArgs?: object | null;
    /**
     * 
     * @type {object}
     * @memberof PlannerMessageResponse
     */
    toolResult?: object | null;
    /**
     * 
     * @type {string}
     * @memberof PlannerMessageResponse
     */
    widgetType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlannerMessageResponse
     */
    createdAt: string;
}

/**
 * Check if a given object implements the PlannerMessageResponse interface.
 */
export function instanceOfPlannerMessageResponse(value: object): value is PlannerMessageResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function PlannerMessageResponseFromJSON(json: any): PlannerMessageResponse {
    return PlannerMessageResponseFromJSONTyped(json, false);
}

export function PlannerMessageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlannerMessageResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'role': json['role'],
        'content': json['content'] == null ? undefined : json['content'],
        'toolName': json['tool_name'] == null ? undefined : json['tool_name'],
        'toolCallId': json['tool_call_id'] == null ? undefined : json['tool_call_id'],
        'toolArgs': json['tool_args'] == null ? undefined : json['tool_args'],
        'toolResult': json['tool_result'] == null ? undefined : json['tool_result'],
        'widgetType': json['widget_type'] == null ? undefined : json['widget_type'],
        'createdAt': json['created_at'],
    };
}

export function PlannerMessageResponseToJSON(json: any): PlannerMessageResponse {
    return PlannerMessageResponseToJSONTyped(json, false);
}

export function PlannerMessageResponseToJSONTyped(value?: PlannerMessageResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'role': value['role'],
        'content': value['content'],
        'tool_name': value['toolName'],
        'tool_call_id': value['toolCallId'],
        'tool_args': value['toolArgs'],
        'tool_result': value['toolResult'],
        'widget_type': value['widgetType'],
        'created_at': value['createdAt'],
    };
}

